import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from 'react-bootstrap/Card'
import '../../index.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs'

import {
    Column,
    Table as ReactTable,
    PaginationState,
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    ColumnDef,
    OnChangeFn,
    flexRender,
} from '@tanstack/react-table'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom';
import { initialQueryState, KTIcon, useDebounce } from '../../../../_metronic/helpers'
import { number } from 'yup'

export function CreateSurvey() {

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const editItem = (data: any) => {
        console.log(data.original)
        navigate('/EditParticipant', { state: data.original });
    };
    const [tableData, setTableData] = useState<any>([])
    //const rerender = React.useReducer(() => ({}), {})[1]
    const API_URL = process.env.REACT_APP_API_URL
    const columns = React.useMemo<ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'image',
                header: () => <span>Profile</span>,
                footer: (props) => props.column.id,
                cell: (props) => <img src={props.row.original.image} className='circleIMG' width={60} />,
            },
            {
                accessorKey: 'firstname',
                header: 'Firstname',
                cell: (props) => <span className='down50'>{props.row.original.firstname}</span>,
                footer: (props) => props.column.id,
            },
            {
                accessorKey: 'lastname',
                header: 'Lastname',
                footer: (props) => props.column.id,
            },
            /*{
              accessorKey: 'email',
              header: 'Email',
              footer: (props) => props.column.id,
            },*/
            {
                accessorKey: 'code',
                header: 'ทะเบียนรถ',
                footer: (props) => props.column.id,
            },

            {
                accessorKey: 'mobile_number',
                header: 'Type',
                footer: (props) => props.column.id,
                cell: (props) => (
                    <p>
                        {''}
                    </p>
                ),
            },

            {
                accessorKey: 'mobile_number',
                header: 'mobile_number',
                footer: (props) => props.column.id,
            },


            {
                accessorKey: 'mobile_number',
                header: 'create date',
                footer: (props) => props.column.id,
                cell: (props) => (
                    <p>
                        {dayjs(props.row.original.created_date).format('DD-MM-YYYY')}
                    </p>
                ),
            },
            {
                accessorKey: 'point',
                header: 'Remain Point',
                footer: (props) => props.column.id,
            },

        ],
        []
    )

    const [data, setData] = React.useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPage, setTotalPage] = useState(1)
    const [totalRow, setTotalRow] = useState(10)
    const getAPI = async () => {
        const data = await axios.get(`${API_URL}/bo/participant?page=1&limit=10`).then((res) => {
            setTableData(res.data.data)
            setData(() => res.data.data)
            setPage(res.data.page)
            setLimit(res.data.limit)
            setTotalRow(res.data.total)
            setTotalPage(Math.ceil(res.data.total / res.data.limit))
        })
        //return data.data.data
    }

    const refreshAPI = async (page: Number, limit: Number) => {
        const data = await axios
            .get(`${API_URL}/bo/participant?page=${page}&limit=${limit}`)
            .then((res) => {
                setTableData(res.data.data)
                setData(() => res.data.data)
                setTotalRow(res.data.total)
                setTotalPage(Math.ceil(res.data.total / res.data.limit))
            })
    }

    const [searchTerm, setSearchTerm] = useState<string>('')
    const refreshAPISearch = async (search: string) => {
        setSearchTerm(search)
        const data = await axios
            .get(`${API_URL}/bo/participant?page=${1}&limit=${limit}&search=${search}`)
            .then((res) => {
                setTableData(res.data.data)
                setData(() => res.data.data)
                setPage(1)
                setTotalRow(res.data.total)
                setTotalPage(Math.ceil(res.data.total / res.data.limit))
            })
    }
    const table = useReactTable({
        data,
        columns,
        // Pipeline
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        //
        debugTable: true,
    })
    useEffect(
        () => {
            getAPI()
        },
        [] // Only re-call effect if value or delay changes
    )

    return (

        <>


            <Card className='table-responsive fontWrap'>
                <Card.Header>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>Create Survey</h3>
                    </div>
                    <div className='d-flex align-items-center position-relative my-1 d-none'>
                        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                        <input
                            type='text'
                            data-kt-user-table-filter='search'
                            className='form-control form-control-solid w-250px ps-14'
                            placeholder='Search user'
                            value={searchTerm}
                            onChange={(e) => refreshAPISearch(e.target.value)}
                        />
                    </div>
                    {/** add button จุดเพิ่มปุ่ม */}
                    {/*<div className='d-flex justify-content-end card-title' data-kt-user-table-toolbar='base'>
          {/*<button type='button' className='btn btn-light-primary me-3'>
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>}

          <button type='button' className='btn btn-primary' onClick={() => {}}>
            <KTIcon iconName='plus' className='fs-2' />
            Add User
          </button>
        </div>*/}
                </Card.Header>

                <div className='card mb-5 mb-xl-10'>
                    {/* <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                >
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>Create Campaign</h3>
                    </div>
                </div> */}

                    <div id='kt_account_profile_details' className='collapse show'>
                        <div className='card-body border-top p-9 row d-flex justify-content-center'>
                            <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                <div className='row'>
                                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>ชื่อแบบสอบถาม</label>
                                </div>
                                <div className='row mb-6'>
                                    <div className='col-lg-12 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                        placeholder=''
                                    />
                                    </div>
                                </div>
                                <div className='row'>
                                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>คำอธิบาย</label>
                                </div>
                                <div className='row mb-6'>
                                    <div className='col-lg-12 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                        placeholder=''
                                    />
                                    </div>
                                </div>
                                <div className='row'>
                                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>คำถามที่ 1</label>
                                </div>
                                <div className='row mb-6'>
                                    <div className='col-lg-12 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                        placeholder=''
                                    />
                                    </div>
                                </div>
                                <div className='row'>
                                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>ประเภทตัวเลือก</label>
                                </div>
                                <div className='row mb-6'>
                                    <div className='col-lg-12 fv-row'>
                                        <select className="form-select form-select-solid form-select-lg">
                                            {/* <option value=''>Select a type campaign..</option> */}
                                            <option value=''>หลายตัวเลือก</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-check form-check-custom form-check-solid pt-3 mb-2">
                                    <input className="form-check-input" name="flexRadioDefault" type="radio" value="" id="flexRadioDefault" />
                                    <label className="form-check-label" htmlFor="flexRadioChecked">
                                        ตัวเลือกที่ 1
                                    </label>
                                </div>

                                <div className="form-check form-check-custom form-check-solid mb-6">
                                    <input className="form-check-input" name="flexRadioDefault" type="radio" value="" id="flexRadioChecked" defaultChecked={true} />
                                    <label className="form-check-label" htmlFor="flexRadioChecked">
                                        ตัวเลือกอื่นๆ หรือเพิ่ม
                                    </label>
                                </div>


                                <div className='row d-flex justify-content-center mb-6'>
                                    <div className='col-lg-4 d-flex justify-content-center'>
                                        <label className="form-check form-switch form-check-custom form-check-solid">
                                            <input className="form-check-input" type="checkbox" value="1"
                                                defaultChecked={true} />
                                            <span className="form-check-label fw-semibold text-muted">บังคับ</span>
                                        </label>
                                    </div>
                                </div>
                                <hr className='mb-6' />
                                <div className='row d-flex justify-content-center mb-6'>
                                    <div className='col-lg-4 d-flex justify-content-center'>
                                        <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_add_user">
                                            <i className="ki-duotone ki-plus fs-2"></i>
                                        </button>
                                    </div>
                                </div>











                                <div className='row mb-6 d-none'>
                                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>กลุ่มเป้าหมาย</label>

                                    <div className='col-lg-8 fv-row'>
                                        <select className="form-select form-select-solid form-select-lg">
                                            {/* <option value=''>Select a target group..</option> */}
                                            <option value='Earn'>All</option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                            {/* <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>ชื่อแคมเปญ</span>
                                </label>

                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                        placeholder='Campaign name'
                                    />
                                </div>
                            </div>

                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>รายละเอียดแคมเปญ</span>
                                </label>

                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                        placeholder='Campaign detail'
                                    />
                                </div>
                            </div> */}

                            <div className='row mb-6 d-none'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>รูปแบบการปรับเพิ่ม</span>
                                </label>

                                <div className='col-lg-8 fv-row'>
                                    <select className="form-select form-select-solid form-select-lg">
                                        {/* <option value=''>Select a target group..</option> */}
                                        <option value='Earn'>จำนวนคะแนนที่ปรับเพิ่ม</option>
                                    </select>
                                </div>
                            </div>

                            {/* <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>จำนวนคะแนนที่ปรับเพิ่ม</span>
                                </label>

                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                        placeholder='Amount point increase'
                                        value={0}
                                    />
                                </div>
                            </div>

                            <div className="input-group" id="kt_td_picker_simple" data-td-target-input="nearest" data-td-target-toggle="nearest">
                                <input id="kt_td_picker_basic_input" type="text" className="form-control" data-td-target="#kt_td_picker_basic" />
                                <span className="input-group-text" data-td-target="#kt_td_picker_basic" data-td-toggle="datetimepicker">
                                    <i className="ki-duotone ki-calendar fs-2"><span className="path1"></span><span className="path2"></span></i>
                                </span>
                            </div> */}

                            {/* <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label fw-bold fs-6'>Communication</label>

                            <div className='col-lg-8 fv-row'>
                                <div className='d-flex align-items-center mt-3'>
                                    <label className='form-check form-check-inline form-check-solid me-5'>
                                        <input
                                            className='form-check-input'
                                            name='communication[]'
                                            type='checkbox'
                                            defaultChecked={true}
                                            onChange={() => {
                                            }}
                                        />
                                        <span className='fw-bold ps-2 fs-6'>Email</span>
                                    </label>

                                    <label className='form-check form-check-inline form-check-solid'>
                                        <input
                                            className='form-check-input'
                                            name='communication[]'
                                            type='checkbox'
                                            defaultChecked={true}
                                            onChange={() => {
                                            }}
                                        />
                                        <span className='fw-bold ps-2 fs-6'>Phone</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className='row mb-0'>
                            <label className='col-lg-4 col-form-label fw-bold fs-6'>Allow Marketing</label>

                            <div className='col-lg-8 d-flex align-items-center'>
                                <div className='form-check form-check-solid form-switch fv-row'>
                                    <input
                                        className='form-check-input w-45px h-30px'
                                        type='checkbox'
                                        id='allowmarketing'
                                        defaultChecked={false}
                                        onChange={() => {
                                        }}
                                    />
                                    <label className='form-check-label'></label>
                                </div>
                            </div>
                        </div> */}
                        </div>

                        <div className='card-footer d-flex justify-content-center pb-6 px-9'>
                            {/* <button className="btn btn-light btn-active-light-primary me-2">Cancel</button> */}
                            <button type='submit' className='btn btn-primary col-8' disabled={loading}>
                                {!loading && 'สร้าง'}
                                {loading && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        Please wait...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                {/* <div className='h-2' /> */}
                {/* <Card.Footer>
                    <div className='card-footer d-flex justify-content-center py-6 px-9'>
                        <button className="btn btn-light btn-active-light-primary me-2">Cancel</button>
                        <button type='submit' className='btn btn-primary' disabled={loading}>
                            {!loading && 'Save'}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    </div>
                </Card.Footer> */}

            </Card>
        </>
    )
}